import React, { useState, useContext } from "react";
import { useQuery } from "react-query";
import { getAllCompletedImages } from "../../services/Image";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { WizardContext, ACTIONS } from "../wizard/Context";

const ImageChecklist = (props) => {
  const { state, dispatch } = useContext(WizardContext);
  const { images = [], releaseName = "" } = state;
  const { onValueUpdated, wizard } = props;
  const [checked, setChecked] = useState(wizard ? images : []);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
    onValueUpdated(newChecked);

    if (wizard) {
      dispatch({
        type: ACTIONS.UPDATE_IMAGES,
        payload: {
          images: newChecked,
          disableNextBtn: releaseName === "" || newChecked.length === 0,
        },
      });
    } else {
      onValueUpdated(newChecked);
    }
  };

  const { data: { data: { res: imageData = [] } = {} } = {} } = useQuery(
    "ImageList",
    getAllCompletedImages,
    {
      refetchOnWindowFocus: false,
    }
  );

  return (
    <FormControl
      component="fieldset"
      sx={{
        width: "100%",
        minHeight: 300,
        overflow: "auto",
        bgcolor: "background.paper",
        mt: 2,
      }}
      variant="standard"
    >
      <p className="helper-text">(Choose atleast one image)</p>
      <FormGroup>
        {imageData.map((ob) => (
          <FormControlLabel
            control={
              <Checkbox
                name="vehicles"
                onClick={() => handleToggle(ob.imageUploadId)}
                defaultChecked={
                  images.includes(ob.imageUploadId) ? true : false
                }
              />
            }
            label={`${ob.fileName} - ${"V" + ob.version}`}
            key={ob.imageUploadId}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

ImageChecklist.defaultProps = {
  onValueUpdated: () => {},
  wizard: false,
};

export default ImageChecklist;
